<template>
  <MonacoEditor language="javascript" />
</template>

<script>
import MonacoEditor from "./components/MonacoEditor.vue";

export default {
  name: "FrontCode",
  components: {
    MonacoEditor,
  },
  data() {
    return {};
  },
  methods: {
    
  },
 
};
</script>